// extracted by mini-css-extract-plugin
module.exports = {"message-content":"message-content__1DkcS","message-content--reverse":"message-content--reverse__o_hmd"};